var collection_toc_obj = {}

function collection_toc_links_on_scroll() {

    let media = window.matchMedia("(max-width: 1310px)");
    let cap = media.matches ? 150 : 100;
    let { anchors, articles } = collection_toc_obj;

    // Reset
    for(let x=0; x<anchors.length; x++) {
        let a = anchors[x];
        a.classList.remove('active');
    }

    for(let x=0; x<articles.length; x++) {
        let isLast = x+1 == articles.length;
        let a = anchors[x];
        let article = articles[x];
        let rect = article.getBoundingClientRect();
        let calc = (rect.top + rect.height) - cap;
        if(calc > 0 || isLast) {
            a.classList.add('active');
            break;
        }
    }
}

document.addEventListener("DOMContentLoaded", (event) => {
    let anchors = document.querySelectorAll('.collection-toc .toc-quick-links a');
    let articles = [];
    for(let x=0; x<anchors.length; x++) {
        let a = anchors[x];
        articles.push(document.getElementById(a.dataset.articleId));
    }
    collection_toc_obj.anchors = anchors;
    collection_toc_obj.articles = articles;
    collection_toc_links_on_scroll();
    window.addEventListener('scroll', function() {
        collection_toc_links_on_scroll();
    }, true)
});